// src/api/collections.ts
import { fetchApi } from '@/config/api';

export interface CollectionOption {
    id_collection: number;
    libelle: string;
}

export async function getCollections(
    lang: 'fr' | 'en' = 'fr',
): Promise<CollectionOption[]> {
    const query = `
    query GetCollections($lang: String!) {
      collections(lang: $lang) {
        id_collection
        libelle
      }
    }
  `;

    const res = await fetchApi<{ collections: CollectionOption[] }>(query, {
        lang,
    });

    return res.collections;
}
